// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qZK6","requiredAsterisk":"Info_requiredAsterisk__2mvjy"};